// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const ChevronCompactDownIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="chevron compact down"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M11.9995 16.7996C11.2995 16.7996 10.5995 16.5296 10.0695 15.9996L3.54953 9.47965C3.25953 9.18965 3.25953 8.70965 3.54953 8.41965C3.83953 8.12965 4.31953 8.12965 4.60953 8.41965L11.1295 14.9396C11.6095 15.4196 12.3895 15.4196 12.8695 14.9396L19.3895 8.41965C19.6795 8.12965 20.1595 8.12965 20.4495 8.41965C20.7395 8.70965 20.7395 9.18965 20.4495 9.47965L13.9295 15.9996C13.3995 16.5296 12.6995 16.7996 11.9995 16.7996Z" fill={fill} />
    </svg>
  );
};

export { ChevronCompactDownIcon };
